<!--<ion-list lines="none" mode="md">-->

@for (task of tasks; track task) {
  <app-task
    [task]="task"
    [showPriorities]="showPriorities"
    [showShowName]="showShowName"
    [viewCheckbox]="checkmarks"
    [viewCreationDate]="viewCreationDate"
    [embedded]="embedded"
    [isSelected]="selectedId === task?.id"
    (taskStatusChanged)="emitChange()"
    (taskSelected)="onTaskSelect($event)"
    class="task__item"
    data-cy="task-component"
    />
}

<!--</ion-list>-->

@if ((!tasks || tasks?.length === 0) && !isLoading) {
  <ion-text class="geen-klussen">Er zijn geen klussen gevonden...
  </ion-text>
}
